import axios from "axios";

const localStorageData = () => {
  let result = localStorage.getItem("1");
  result = JSON.parse(result);
  if (result) {
    return result;
  } else {
    return "";
  }
};

export default async function tokenUpdate(token) {
  const url = `${window?.config?.REACT_APP_BASE_URL || ""}`;
  let userData = localStorageData();

  try {
    const response = await axios.post(
      `${url}/refreshTokenClient`,
      { refresh_tokenClient: userData.refreshToken.usuarioClienteId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.data.token) {
      userData.token = response.data.token;
      userData.refreshToken = response.data.newRefreshTokenCliente;
      localStorage.setItem("1", JSON.stringify(userData));
    } else {
      //console.log("response", response.data);
    }
  } catch (error) {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      console.error(error);
    }
  }
}
